import { render, staticRenderFns } from "./FunnelContainer.vue?vue&type=template&id=2b4b5c4e&scoped=true&"
import script from "./FunnelContainer.vue?vue&type=script&lang=js&"
export * from "./FunnelContainer.vue?vue&type=script&lang=js&"
import style0 from "./FunnelContainer.vue?vue&type=style&index=0&id=2b4b5c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b5c4e",
  null
  
)

export default component.exports